import { NAME_SPACE } from './constants'
import { 
    getProjectListApi,
    getProjectItemTableApi,
    setBalanceNumberApi,
    getRecordsListApi,
    createRecordItemApi,
    deleteRecordItemApi,
    getBankbalanceSettingApi
 } from './service'
// getHistoryDataApi
const state_init = () => ({
    projectList:[],
    projectItemTable:[],
    recordsList:[],
    bankbalanceSetting:[],
    loading:{
        getProjectListLoading:false,
        getProjectItemTableLoading:false,
        setBalanceNumberLoading:false,
        getRecordsListLoading:false,
        createRecordItemLoading: false,
        getBankbalanceSettingLoading:false,
    }
})
const model = {
    name: NAME_SPACE,
    namespaced: true,
    state: state_init(),
    mutations: {
        setStateLevel0(state,params) {
            if (Object.prototype.toString.call(params) === '[object Object]') {
                const { key, value} = params
                state[key] = value
                return 
            }
            for (const item of params) {
                const { key, value} = item
                state[key] = value
            }
        },
        setLoading(state,{ key,value }) {
            state.loading[key] = value
        },
        detialEditDestryed(state) {
            state.tree = []
        },
        initState(state) {
            const currentState = state_init()
            Object.keys(currentState).forEach(key => {
                state[key] = currentState[key]
            })
        }
    },
    actions: {
        async getProjectList({ commit },{successCall,...params}) { // 获取集团、公司、银行等信息
            commit('setLoading',{ key:'getProjectListLoading', value:true })
            const result = await getProjectListApi(params,() => { 
                    commit('setLoading',{ key:'getProjectListLoading', value:false })
                 })
            if (successCall) {
                successCall(result)
            }
            commit('setStateLevel0',{ key:'projectList', value:result })
        },
        async getProjectItemTable({ commit },params) { 
            commit('setLoading',{ key:'getProjectItemTableLoading', value:true })
            commit('setStateLevel0',{ key:'projectItemTable', value: [] })
            const result = await getProjectItemTableApi(params,() => {
                commit('setLoading',{ key:'getProjectItemTableLoading', value:false })
            })
            commit('setStateLevel0',{ key:'projectItemTable', value:result })
        },
        async setBalanceNumber({ commit },{ closeModal,getData,...params}) { // 设置余额
            commit('setLoading',{ key:'setBalanceNumberLoading', value:true })
            await setBalanceNumberApi(params,() => { 
                commit('setLoading',{ key:'setBalanceNumberLoading', value:false })
            })
            closeModal()
            getData()
        },
        async getRecordsList({ commit },params) { // 获取分红记录
            commit('setLoading',{ key:'getRecordsListLoading', value:true })
            commit('setStateLevel0',{ key:'recordsList', value: [] })
            const result = await getRecordsListApi(params,() => { 
                commit('setLoading',{ key:'getRecordsListLoading', value:false })
             })
             commit('setStateLevel0',{ key:'recordsList', value: (result && result.dividends) || [] })
        },
        async createRecordItem({ commit },{ closeModal,getData,...params}) {
            commit('setLoading',{ key:'createRecordItemLoading', value:true })
            const result = await createRecordItemApi(params,() => { // 新建/编辑条目
                commit('setLoading',{ key:'createRecordItemLoading', value:false })
            })
             closeModal()
             getData(result.dividend)
        },
        async deleteRecordItem(action,{id,call}) {
            await deleteRecordItemApi({id},() => { // 删除条目
                call()
            })
        },
        async getBankbalanceSetting({ commit },params) {
            commit('setLoading',{ key:'getBankbalanceSettingLoading', value:true })
            commit('setStateLevel0',{ key:'bankbalanceSetting', value: [] })
            const result = await getBankbalanceSettingApi(params,() => { 
                commit('setLoading',{ key:'getBankbalanceSettingLoading', value:false })
            })
            commit('setStateLevel0',{ key:'bankbalanceSetting', value: result || [] })
        }
    }
  };
  
  export default model;
  
